import Period from "@/types/Period";
import moment from "moment";
import VueI18n from "vue-i18n";

class AllocationUtils {
    private _i18n: VueI18n;
    constructor(i18n: VueI18n) { //t: typeof VueI18n.prototype.t
        this._i18n = i18n;
    }

    public NullDate: Date = new Date(-62135597361000);

    /**
     * Genere le label de la période à partir des dates de début et de fin
     * @param startDate 
     * @param endDate 
     * @returns { string } label de la période
     */
    public GeneratePeriodLabel(startDate: Date, endDate: Date)
    {
        let _periodLabel: string = ``;

        if(!this.IsValidDate(startDate).key && this.IsValidDate(startDate).value != "" || !this.IsValidDate(endDate).key && this.IsValidDate(endDate).value != "")
        {
            _periodLabel += this._i18n.t('UnValidDate').toString();
        } 
        else 
        {
            if(!this.IsValidDate(startDate).key && this.IsValidDate(startDate).value == "" || startDate.toString() === '0001-01-01T00:00:00')
                _periodLabel += this._i18n.t('UpTo').toString();
            else _periodLabel += this._i18n.t('FromDate', { StartDate: moment(startDate).format('DD/MM/yyyy') }).toString();

            if(!this.IsValidDate(endDate).key && this.IsValidDate(endDate).value == "" || endDate.toString() === '0001-01-01T00:00:00')
                _periodLabel += this._i18n.t('ToToday').toString();
            else _periodLabel += this._i18n.t('ToDate', { EndDate: moment(endDate).format('DD/MM/yyyy') }).toString();
        }
        
        return _periodLabel;
    }

    /**
     * Vérifie si la date est valide
     * @param value 
     * @returns { {key: boolean, value: string} } : objet avec la clé de validité et la valeur de la date
     */
    public IsValidDate(value)
    {
        if(!this.IsNullDate(value))
        {
            if(new Date(value).getFullYear() < 1970)
            {
                return { key : false, value: this._i18n.t('TooOld').toString() };
            } 
            else if (value > new Date())
            {
                return { key : false, value: this._i18n.t('SuperiorThanTodaysDate').toString() };
            } 
            else
            {
                return {key : true, value: value};
            }
        } 
        else 
        {
            return {key: false, value: ""};
        }
    };

    /**
     * Vérifie si la date est nulle
     * @param value 
     * @returns { boolean } : true si la date est nulle, false sinon
     */
    public IsNullDate(value) : boolean
    {
        return !(value && ((value instanceof Date) && !isNaN(value.valueOf()) || typeof value === 'string'));
    };
    
    /**
     * 
     * @param period 
     * @returns 
     */
    public Sort(period: Period[]) : Period[]
    {
        period.sort((a, b) => {
            return new Date(a.StartDate)?.getTime() - new Date(b.StartDate)?.getTime();
        })

        return period;
    }

    /**
     * Retourne une copie profonde de l'objet passé en paramètre pour garder toutes références, comme les getters et setters
     * @param obj 
     * @returns 
     */
    public DeepClone<T>(obj: T): T {
        let prototype = Object.getPrototypeOf(obj);
        let copy = Object.create(prototype);
        return Object.defineProperties(copy, Object.getOwnPropertyDescriptors(obj));
    }
}
export default AllocationUtils;